import { render } from "./App.vue?vue&type=template&id=22972b59&scoped=true"
import script from "./App.vue?vue&type=script&lang=javascript"
export * from "./App.vue?vue&type=script&lang=javascript"

import "./App.vue?vue&type=style&index=0&id=22972b59&lang=css&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22972b59"]])

export default __exports__